// components/Header.jsx
import React, { useState, useEffect } from "react";
import "./Header.css";
import logoImage from "../image/kadaipos_logo_transparent.png";
import { useNavigate, useLocation } from "react-router-dom";
import { ChevronDown, Menu, X } from "lucide-react";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const handleScroll = (e, id) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        const section = document.getElementById(id);
        if (section) section.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
        setIsMenuOpen(false);
      }
    }
  };

  const outletTypes = [
    { name: "Restaurant", route: "/restaurantfeature", icon: "🍽️" },
    { name: "Cafe", route: "/coffeefeature", icon: "☕" },
    { name: "Bakery", route: "/bakeryfeature", icon: "🧁" },
    { name: "Cloud Kitchen", route: "/cloudkitchenfeature", icon: "🍳" },
    { name: "Ice Cream & Dessert", route: "/icecreamfeature", icon: "🍨" },
    { name: "Food Court", route: "/foodcourtfeature", icon: "🍔" },
  ];

  const navigateTo = (route) => {
    navigate(route);
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? "header--scrolled" : ""}`}>
      <div className="container">
        <nav className="header__nav">
          {/* Logo */}
          <div className="header__logo" onClick={() => navigateTo("/")}>
            <img src={logoImage} alt="KadaiPOS Logo" />
          </div>

          {/* Desktop Navigation */}
          <div className="header__links">
            <a href="#features" onClick={(e) => handleScroll(e, "features")}>
              Features
            </a>
            <a href="#pricing" onClick={(e) => handleScroll(e, "pricing")}>
              Pricing
            </a>
            <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
              FAQ
            </a>
            <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
              Contact
            </a>

            {/* Outlet Types Dropdown */}
            <div className="header__dropdown">
              <button className="header__dropdown-btn">
                Outlet Types <ChevronDown size={16} />
              </button>
              <div className="header__dropdown-menu">
                {outletTypes.map((item) => (
                  <div
                    key={item.name}
                    className="header__dropdown-item"
                    onClick={() => navigateTo(item.route)}
                  >
                    <span className="header__dropdown-icon">{item.icon}</span>
                    <span>{item.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* CTA Button */}
          <div className="header__actions">
            <button
              className="btn btn-primary header__cta"
              onClick={(e) => handleScroll(e, "contact")}
            >
              Get Started
            </button>
          </div>

          {/* Mobile Hamburger */}
          <button
            className="header__hamburger"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </nav>
      </div>

      {/* Mobile Menu Overlay */}
      {isMenuOpen && (
        <div className="header__overlay" onClick={() => setIsMenuOpen(false)} />
      )}

      {/* Mobile Slide-in Menu */}
      <div className={`header__mobile ${isMenuOpen ? "header__mobile--open" : ""}`}>
        <div className="header__mobile-links">
          <a href="#features" onClick={(e) => handleScroll(e, "features")}>
            Features
          </a>
          <a href="#pricing" onClick={(e) => handleScroll(e, "pricing")}>
            Pricing
          </a>
          <a href="#faq" onClick={(e) => handleScroll(e, "faq")}>
            FAQ
          </a>
          <a href="#contact" onClick={(e) => handleScroll(e, "contact")}>
            Contact
          </a>

          <div className="header__mobile-divider" />

          <span className="header__mobile-label">Outlet Types</span>
          {outletTypes.map((item) => (
            <div
              key={item.name}
              className="header__mobile-outlet"
              onClick={() => navigateTo(item.route)}
            >
              <span>{item.icon}</span>
              <span>{item.name}</span>
            </div>
          ))}

          <button
            className="btn btn-primary header__mobile-cta"
            onClick={(e) => handleScroll(e, "contact")}
          >
            Get Started
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
